export let AdvancedSettingCategory = /*#__PURE__*/function (AdvancedSettingCategory) {
  AdvancedSettingCategory["Pricing"] = "Pricing";
  AdvancedSettingCategory["Billing"] = "Billing";
  AdvancedSettingCategory["Integrations"] = "Integrations";
  return AdvancedSettingCategory;
}({});
export let AdvancedSetting = /*#__PURE__*/function (AdvancedSetting) {
  AdvancedSetting["Pause"] = "pause";
  AdvancedSetting["BillOnApproval"] = "billOnApproval";
  AdvancedSetting["Prorate"] = "prorate";
  AdvancedSetting["Optional"] = "optional";
  AdvancedSetting["LimitCharges"] = "limitCharges";
  AdvancedSetting["AutoPriceIncrease"] = "autoPriceIncrease";
  AdvancedSetting["QboClasses"] = "qboClasses";
  AdvancedSetting["FinancialCents"] = "financialCents";
  AdvancedSetting["Karbon"] = "karbon";
  AdvancedSetting["LimitedTimeDiscountOffer"] = "limitedTimeDiscountOffer";
  AdvancedSetting["LimitedTimeDiscountOfferForAgreement"] = "limitedTimeDiscountOfferForAgreement";
  AdvancedSetting["PreapprovedAmount"] = "preapprovedAmount";
  AdvancedSetting["StartAutomaticBillingAt"] = "startAutomaticBillingAt";
  return AdvancedSetting;
}({});
export let IncreaseMethod = /*#__PURE__*/function (IncreaseMethod) {
  IncreaseMethod["EffectiveDate"] = "effectiveDate";
  IncreaseMethod["Date"] = "date";
  return IncreaseMethod;
}({});
export const ADVANCED_SETTING_CATEGORY_MAP = {
  [AdvancedSetting.LimitedTimeDiscountOffer]: AdvancedSettingCategory.Pricing,
  [AdvancedSetting.LimitedTimeDiscountOfferForAgreement]: AdvancedSettingCategory.Pricing,
  [AdvancedSetting.AutoPriceIncrease]: AdvancedSettingCategory.Pricing,
  [AdvancedSetting.StartAutomaticBillingAt]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.LimitCharges]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.PreapprovedAmount]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.Optional]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.BillOnApproval]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.Prorate]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.Pause]: AdvancedSettingCategory.Billing,
  [AdvancedSetting.QboClasses]: AdvancedSettingCategory.Integrations,
  [AdvancedSetting.FinancialCents]: AdvancedSettingCategory.Integrations,
  [AdvancedSetting.Karbon]: AdvancedSettingCategory.Integrations
};